export default __webpack_public_path__ + "static/media/Web_06-01.0b15e176.png";